import { Injectable } from '@angular/core';

@Injectable()
export class Constants {
  static readonly MANDATORY: string = 'MANDATORY';
  static readonly REGEX_WHITESPACES: string = '^[^ ]+(?:\\s+[^ ]+)*$';

  static readonly COOKIE_ACCESS_TOKEN = 'access_token';
  static readonly HEADER_AUTHORIZATION = 'Authorization';
  static readonly HEADER_ACCEPT = 'Accept';
  static readonly HEADER_CONTENT_TYPE = 'Content-Type';
}
